var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashQuickLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.301,
    height: 20.301,
    viewBox: "0 0 20.301 20.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link",
    transform: "translate(0.012 -0.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29268",
    "data-name": "Path 29268",
    d: "M10.175,20.319a10,10,0,1,1,9.964-10,10,10,0,0,1-9.964,10Zm0-18.993a8.993,8.993,0,1,0,8.957,8.993A8.993,8.993,0,0,0,10.175,1.326Z",
    transform: "translate(0 0)",
    fill: "#bebfb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29268_-_Outline",
    "data-name": "Path 29268 - Outline",
    d: "M10.138,20.469a10.163,10.163,0,1,1,.037,0Zm0-20a9.85,9.85,0,1,0,0,19.7h.036a9.85,9.85,0,0,0-.033-19.7Zm0,18.994h0a9.144,9.144,0,1,1,0-18.287h.037A9.143,9.143,0,0,1,13.629,18.77,9.094,9.094,0,0,1,10.141,19.463Zm0-17.987a8.843,8.843,0,1,0,.036,0Z",
    transform: "translate(0 0)",
    fill: "#bebfb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29269",
    "data-name": "Path 29269",
    d: "M27.822,50.355a2.772,2.772,0,0,1-1.959-4.73l1.355-1.353a.5.5,0,0,1,.711.711l-1.355,1.347a1.765,1.765,0,0,0,2.5,2.5l1.355-1.355a.5.5,0,0,1,.711.711l-1.353,1.355a2.77,2.77,0,0,1-1.961.819Z",
    transform: "translate(-19.9 -35.004)",
    fill: "#bebfb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29269_-_Outline",
    "data-name": "Path 29269 - Outline",
    d: "M27.823,50.5h0a2.922,2.922,0,0,1-2.064-4.986l1.361-1.358a.653.653,0,0,1,.922.922l-.006.006L26.68,46.435a1.615,1.615,0,0,0,2.284,2.283l1.36-1.36a.653.653,0,0,1,.922.922l-.006.006-1.353,1.355A2.939,2.939,0,0,1,27.823,50.5Zm-.5-6.123L25.97,45.731a2.618,2.618,0,1,0,3.707,3.7l1.35-1.352a.353.353,0,0,0-.5-.5l-1.351,1.351a1.915,1.915,0,0,1-2.708-2.708l1.352-1.344a.353.353,0,0,0-.5-.5Z",
    transform: "translate(-19.9 -35.004)",
    fill: "#bebfb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29270",
    "data-name": "Path 29270",
    d: "M47.785,31.271a.505.505,0,0,1-.356-.859l1.355-1.355a1.765,1.765,0,0,0-2.5-2.5l-1.355,1.355a.5.5,0,0,1-.711-.711l1.353-1.355a2.772,2.772,0,1,1,3.919,3.921l-1.355,1.353A.5.5,0,0,1,47.785,31.271Z",
    transform: "translate(-35.108 -19.744)",
    fill: "#bebfb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29270_-_Outline",
    "data-name": "Path 29270 - Outline",
    d: "M47.787,31.421h0a.655.655,0,0,1-.463-1.115l1.356-1.356a1.615,1.615,0,0,0-2.284-2.284l-1.36,1.36a.653.653,0,0,1-.922-.922l.006-.006,1.353-1.355A2.922,2.922,0,1,1,49.6,29.878L48.245,31.23A.649.649,0,0,1,47.787,31.421ZM47.535,25.9a1.913,1.913,0,0,1,1.354,3.267l-1.355,1.355a.355.355,0,0,0,.251.6v0a.347.347,0,0,0,.245-.1l1.355-1.353a2.622,2.622,0,0,0-3.707-3.709l-1.349,1.351a.353.353,0,0,0,.5.5l1.351-1.351A1.907,1.907,0,0,1,47.535,25.9Z",
    transform: "translate(-35.108 -19.744)",
    fill: "#bebfb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29271",
    "data-name": "Path 29271",
    d: "M39.488,43.511a.5.5,0,0,1-.356-.857l3.422-3.422a.5.5,0,0,1,.711.711l-3.422,3.422A.5.5,0,0,1,39.488,43.511Z",
    transform: "translate(-31.028 -30.978)",
    fill: "#bebfb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29271_-_Outline",
    "data-name": "Path 29271 - Outline",
    d: "M39.488,43.661h0a.653.653,0,0,1-.463-1.113l3.428-3.428a.653.653,0,0,1,.922.922l-.006.006L39.948,43.47A.653.653,0,0,1,39.488,43.661Zm3.168-4.32L39.237,42.76a.353.353,0,0,0,.251.6v0a.351.351,0,0,0,.247-.1l3.419-3.419a.353.353,0,0,0-.5-.5Z",
    transform: "translate(-31.028 -30.978)",
    fill: "#bebfb6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashQuickLink);
export default __webpack_public_path__ + "static/media/dash-quick-link.1f12708f1b9374813115a79fb6d228b2.svg";
export { ForwardRef as ReactComponent };